import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class Miracle extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            RPGONE Translations - Miracle Girls - English Translation v1.1 SNES
            - ミラクル★ガールズ
          </title>
          <meta
            name="title"
            content="RPGONE Translations - Miracle Girls - English Translation v1.1 SNES - ミラクル★ガールズ"
          />
          <meta
            name="description"
            content="Miracle Girls Snes English Translation v1.3 - Twin sisters Tomomi and Mikage Matsunaga have ESP powers but they try to hide this from their friends. Only Mr. Kageura knows their secret! Tomomi is tomboyish and athletic, while Mikage is feminine and intellectual. - SNES / Super Famicom / Super Nintendo by RPGONE Translations"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered">
                {/*<h3>Miracle Girls - English Translation</h3>
            <i><div> ミラクル★ガールズ</div></i>*/}
              </span>
              <div className="center-image">
                <img
                  src={require("./img/proj/miracle1.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle2.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle3.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle5.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle7.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle8.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle9.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/miracle10.png")}
                  alt=""
                  className="imageResize"
                />
                <br />
                <br />
                <i>
                  <div>
                    Miracle Girls<br />Original release: 22nd October 1993 on
                    Super Famicom (Snes / Super Nintendo)
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Story</div>
              </b>
              <br />
              Miracle Girls is based on a manga by Nami Akimoto. It was later
              adapted into a TV anime series. The manga is about twin sisters
              Tomomi and Mikage Matsunaga, and their love lives in high school.
              Tomomi is tomboyish and athletic, while Mikage is feminine and
              intellectual. These twins have ESP powers but they try to hide
              this from their friends. Only Mr. Kageura knows their secret!<br />
              <br />
              In the game, the sisters and their friends are suddenly teleported
              to a strange and magical world. You must help them find their
              missing friends and defeat Majo-Majo's villains by throwing candy
              as your only weapon, and eventually find the way back home.
              <br />
              <br />
              <div className="center-image">
                <a href={require("./img/box/Miracle Girls - Box Cover.jpg")}>
                  <img
                    src={require("./img/box/Miracle Girls - Box Cover.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a href={require("./img/box/Miracle Girls - Box Back.jpg")}>
                  <img
                    src={require("./img/box/Miracle Girls - Box Back.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Downloads</div>
              </b>
              <br />
              <a
                href={require("./files/Miracle Girls - English v1.1.zip")}
                download="Miracle Girls - English v1.1.zip"
              >
                English Translation patch v1.1
              </a>{" "}
              by RPGONE
              <br />
              <br />
              <a href="https://www.romhacking.net/translations/781">
                Project page on romhacking.net
              </a>
              <br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>PAR Codes</div>
              </b>
              <br />
              <b>7E00BE02</b> - Always win the minigame
              <br />
              <br />
              <b>7E01B240</b> - Always get bonus screen after each stage
              <br />
              <br />
              <code-container>
                <row-section>
                  <b>7E0094 - Stage select</b>
                </row-section>
                <row-section-leftpadding>00</row-section-leftpadding>
                <row-section>- Stage 1 - Flower Road</row-section>

                <row-section />
                <row-section-leftpadding>01</row-section-leftpadding>
                <row-section>- Stage 2 - Clouds Island</row-section>

                <row-section />
                <row-section-leftpadding>02</row-section-leftpadding>
                <row-section>- Stage 3 - Sweet Hill</row-section>

                <row-section />
                <row-section-leftpadding>03</row-section-leftpadding>
                <row-section>- Stage 4 - Toys Bridge</row-section>

                <row-section />
                <row-section-leftpadding>04</row-section-leftpadding>
                <row-section>- Stage 5 - Magical Forest</row-section>
              </code-container>
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Miracle);



// WEBPACK FOOTER //
// ./src/Miracle.js